export const HOME = "/";
export const ACADEMIC = "/academic";
export const RESEARCH_EXPERIENCES = "/research-experiences";
export const PROJECTS = "/projects";
export const EXPERIENCES = "/experiences";
export const ART_PHOTOGRAPHY = "/art-photography";
export const AWARDS_ACHIEVEMENTS = "/award-achievements";
export const EXTRA_CURRICULAR_ACTIVITIES = "/extra-curricular-activities";
export const GALLERY = "/gallery";
export const ABOUT = "/about";
